import { Dialog, DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { Role } from '@shared/enums/role.enum';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faShield } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '@shared/components/button';
import { IconDirective } from '@ui/components/icon';
import { AuthModalLayoutComponent } from '../auth-modal-layout/auth-modal-layout.component';
import { ForgotPasswordModalComponent } from '../forgot-password-modal/forgot-password-modal.component';
import { LoginFormService } from './login-form.service';
import { CloseModalDirective } from '@shared/directives';
import { LoginModalConfig } from './interfaces/login-modal-config.interface';
import { LoginSubmitDirective } from './directives/login-submit.directive';
import { CcsInputComponent } from '@shared/components/ccs-input/ccs-input.component';
import { LOGIN_ERROR_MESSAGES } from './constants';

@Component({
  selector: 'app-login-modal',
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    IconDirective,
    AuthModalLayoutComponent,
    FaIconComponent,
    CloseModalDirective,
    LoginSubmitDirective,
    CcsInputComponent,
  ],
  templateUrl: './login-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LoginFormService],
})
export class LoginModalComponent {
  private readonly dialogRef = inject(DialogRef);

  protected readonly modalData: LoginModalConfig = inject(DIALOG_DATA);
  private readonly dialog = inject(Dialog);
  private readonly _formService = inject(LoginFormService);

  protected passwordVisible = signal(false);

  protected readonly passwordIcon = computed(() =>
    this.passwordVisible() ? 'visibility' : 'visibility_off',
  );

  protected readonly passwordType = computed(() =>
    this.passwordVisible() ? 'text' : 'password',
  );

  protected readonly ERROR_MESSAGES = LOGIN_ERROR_MESSAGES;
  protected readonly loginForm = this._formService.form;

  protected Role = Role;
  protected shieldIcon = faShield;
  protected sending = this._formService.isLoading;

  protected openForgotPassword() {
    if (this.sending()) return;

    this.dialogRef.close();
    this.dialog.open(ForgotPasswordModalComponent, {
      data: this.modalData,
    });
  }

  protected togglePasswordVisibility() {
    this.passwordVisible.update((v) => !v);
  }
}
